export default __webpack_public_path__ + "assets/front/scss/user-authentication.3449799226b955e8d3af53c02e6e1992.css";